/**
 * APH product finder quiz - demos parity (shared/quiz.js)
 * Shopify cart via /cart/add.js
 */
(function () {
  'use strict';

  var STAR_SVG =
    '<svg viewBox="0 0 256 256" width="12" height="12" aria-hidden="true"><path fill="currentColor" d="M234.29,114.85l-45,38.83L203,211.75a16.4,16.4,0,0,1-24.5,17.82L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,59,4.76a16.46,16.46,0,0,1,9.37,28.86Z"/></svg>';

  function readJson(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function money(amount) {
    var n = parseFloat(String(amount).replace(/,/g, ''));
    if (isNaN(n)) return '£' + amount;
    return '£' + n.toFixed(2);
  }

  /* Harry 2026-08-17: "recommendations are basic/generic/samey" - replaced
     the old ~20-product / 12-fixed-branch lookup table with a scoring
     engine that matches real product tags (bulking, strength, Weight
     Loss, recovery, testosterone, mens, pct, sarms, best-sellers) across
     the full active catalogue (~50 products, see sections/aph-quiz.liquid
     handle list + emitted "tags"). Same 3-question flow, richer answers
     underneath it. Also "products can be condensed": capped 4 -> 3 picks
     (aph-quiz.css grid updated to match). */

  function hasTag(p, tag) {
    if (!p || !p.tags) return false;
    var list = Array.isArray(p.tags) ? p.tags : String(p.tags).split(',');
    var needle = String(tag).toLowerCase();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i]).trim().toLowerCase() === needle) return true;
    }
    return false;
  }

  function isProteinItem(p) {
    return !!(p && (p.is_protein || /whey/i.test(p.handle || '')));
  }

  /* Harry 2026-09-23 (dedicated quiz pass): 2 questions only - goal +
     open-to (diet + protein killed). Always 4 cards. Locked packs below;
     scoring engine survives only as top-up fallback if a pack product is
     missing from the catalogue. */
  var GOAL_TAG = { bulking: 'bulking', strength: 'strength', weightloss: 'weight loss', recovery: 'recovery' };
  var GOAL_LABEL = { bulking: 'bulking', strength: 'strength', weightloss: 'weight loss', recovery: 'recovery' };
  var GOAL_NAME = { bulking: 'Bulking', strength: 'Strength', weightloss: 'Weight loss', recovery: 'Recovery' };
  var PATH_NAME = { natty: 'Natural only', sarms: 'Open to SARMs', peptides: 'Open to peptides' };

  /* Locked packs (Harry 2026-09-23). Peptides path ignores goal.
     bulking+sarms leads with the two AF Harry called perfect (Anabolic +
     Stacked), padded with Bulked + Jacked - never Shredded AF. Peptides =
     BPC-157 pills + TB-500 pills, padded with GLP-1 capsule + 5-Amino
     capsule: no vials, no coming-soon, no Hyper, nothing discontinued. */
  var PACKS = {
    'bulking|natty': ['whey-protein-white-chocolate', 'creatine-gummies-mix-berry-flavour', 'lions-mane-gummies-2-500mg', 'whey-protein-mint-choc-chip'],
    'bulking|sarms': ['anabolic-af', 'stacked-af', 'bulked-af-triple-compound-stack-for-bulking', 'jacked-af'],
    'weightloss|natty': ['glp-1-weight-management-capsule', 'whey-protein-white-chocolate', 'creatine-gummies-mix-berry-flavour', 'lions-mane-gummies-2-500mg'],
    'weightloss|sarms': ['shredded-af', 'cardarine-gw-50156', 'glp-1-weight-management-capsule', 'whey-protein-white-chocolate'],
    'strength|natty': ['creatine-monohydrate-1000mg', 'whey-protein-white-chocolate', 'tongkat-ali', 'creatine-gummies-mix-berry-flavour'],
    'strength|sarms': ['jacked-af', 'alpha-af', 'rad-140', 'creatine-monohydrate-1000mg'],
    'recovery|natty': ['whey-protein-mint-choc-chip', 'lions-mane-gummies-2-500mg', 'creatine-gummies-mix-berry-flavour', 'tongkat-ali'],
    'recovery|sarms': ['rad-140', 'alpha-af', 'creatine-monohydrate-1000mg', 'whey-protein-mint-choc-chip']
  };
  var PEPTIDE_PACK = ['bpc-157-30mg', 'tb-500', 'glp-1-weight-management-capsule', '5-amino-1-mq-50mg-x-60-capsules'];

  var AF_HANDLES = ['anabolic-af', 'alpha-af', 'stacked-af', 'jacked-af', 'bulked-af-triple-compound-stack-for-bulking', 'shredded-af'];
  var AF_BULK_PREF = ['bulked-af-triple-compound-stack-for-bulking', 'anabolic-af', 'stacked-af'];
  var AF_STRENGTH_PREF = ['jacked-af', 'alpha-af'];
  var SHRED_HANDLES = ['shredded-af', 'shred-stack'];
  /* Harry 2026-09-23: killed stacks - never recommend these in the quiz. */
  var QUIZ_BLOCKLIST = ['monster-stack', 'alpha-stack', 'growth-stack', 'titan-stack', 'summer-stack-2026', 'elite-stack', 'santa-s-stack', 'bovine-collagen-400mg', 'bovine-collagen'];

  function isAF(p) {
    return !!(p && AF_HANDLES.indexOf(p.handle) !== -1);
  }

  /* Is this product even allowed down the chosen path? (Natural only
     excludes SARMs + Peptides entirely, matching the step-2 copy. SARMs /
     Peptides paths stay open to everything except the OTHER research
     category, same as the original branches did. AF range counts as
     SARMs-side research compounds.) */
  function isAllowedInPath(p, path) {
    var isSarms = hasTag(p, 'sarms') || isAF(p);
    var isPeptide = p.tag === 'Peptides';
    if (path === 'natty') return !isSarms && !isPeptide;
    if (path === 'sarms') return !isPeptide;
    if (path === 'peptides') return !isSarms;
    return true;
  }

  function scoreProduct(p, state) {
    var score = 0;
    var goalTag = GOAL_TAG[state.goal];
    if (goalTag && hasTag(p, goalTag)) score += 3;
    if (state.natty === 'sarms' && (hasTag(p, 'sarms') || isAF(p))) score += 3;
    if (state.natty === 'peptides' && p.tag === 'Peptides') score += 3;
    if (hasTag(p, 'best-sellers')) score += 1;
    if ((state.goal === 'bulking' || state.goal === 'strength') && hasTag(p, 'testosterone')) score += 2;
    if ((state.goal === 'bulking' || state.goal === 'strength') && hasTag(p, 'mens')) score += 1;
    if (state.goal === 'recovery' && hasTag(p, 'health')) score += 1;
    if (state.natty !== 'natty' && (state.goal === 'bulking' || state.goal === 'strength') && (hasTag(p, 'pct') || hasTag(p, 'mens'))) score += 1;
    /* AF range goal match - bulking prefers Bulked > Anabolic > Stacked,
       a cut prefers Shredded AF, strength prefers Jacked > Alpha. */
    if (state.goal === 'bulking') {
      var bi = AF_BULK_PREF.indexOf(p.handle);
      if (bi !== -1) score += 14 - bi * 2;
    }
    if (state.goal === 'weightloss' && p.handle === 'shredded-af') score += 10;
    if (state.goal === 'strength') {
      var si = AF_STRENGTH_PREF.indexOf(p.handle);
      if (si !== -1) score += 8 - si;
    }
    return score;
  }

  function writeBlurb(p, state, isPrimary) {
    if (isProteinItem(p)) {
      return 'Quality whey - the daily protein driver for ' + (GOAL_LABEL[state.goal] || 'your goal') + '.';
    }
    var bits = [];
    if (isPrimary) {
      if (state.natty === 'sarms' && (hasTag(p, 'sarms') || isAF(p))) {
        bits.push('Open to SARMs - ' + (p.name || p.handle) + ' is our top match for ' + (GOAL_LABEL[state.goal] || 'this goal') + '.');
      } else if (state.natty === 'peptides' && p.tag === 'Peptides') {
        bits.push('Open to peptides - ' + (p.name || p.handle) + ' is the research peptide we lead with for ' + (GOAL_LABEL[state.goal] || 'this goal') + '.');
      } else {
        bits.push((p.name || p.handle) + ' is our top natural match for ' + (GOAL_LABEL[state.goal] || 'this goal') + '.');
      }
    }
    if (hasTag(p, 'testosterone')) bits.push('Supports natural testosterone, which underpins both size and strength.');
    if (hasTag(p, 'pct')) bits.push('Suppressive compounds still need proper PCT - this protects what you build.');
    if (hasTag(p, 'recovery') && state.goal === 'recovery') bits.push('Aimed squarely at recovery - tissue and joint support, not just output.');
    if (isAF(p)) bits.push('Triple-compound stack from the AF range - built for ' + (GOAL_LABEL[state.goal] || 'this goal') + '.');
    if (p.tag === 'Stacks') bits.push('A full stack if you want more coverage than a single compound.');
    if (!bits.length) bits.push('A solid pick alongside your primary compound for ' + (GOAL_LABEL[state.goal] || 'this goal') + '.');
    return bits.join(' ');
  }

  function buildCombo(state, cat) {
    var path = state.natty;
    var seen = {};
    var picks = [];
    function addPick(p) {
      if (!p || !p.handle || seen[p.handle]) return false;
      seen[p.handle] = true;
      picks.push(p);
      return true;
    }

    /* Locked pack first - Harry's exact four. */
    var packHandles = path === 'peptides' ? PEPTIDE_PACK : (PACKS[state.goal + '|' + path] || []);
    packHandles.forEach(function (h) {
      if (QUIZ_BLOCKLIST.indexOf(h) !== -1) return;
      if (picks.length < 4) addPick(cat[h]);
    });

    /* Top-up fallback (only if a pack handle dropped out of the
       catalogue): score remaining products down the same path. */
    if (picks.length < 4) {
      var candidates = [];
      Object.keys(cat).forEach(function (handle) {
        var p = cat[handle];
        if (!p || isProteinItem(p)) return;
        if (QUIZ_BLOCKLIST.indexOf(p.handle) !== -1) return;
        if (!isAllowedInPath(p, path)) return;
        /* Harry: never show shred products for a bulking goal. */
        if (state.goal === 'bulking' && SHRED_HANDLES.indexOf(p.handle) !== -1) return;
        candidates.push(p);
      });
      candidates.forEach(function (p) {
        p._score = scoreProduct(p, state);
      });
      candidates.sort(function (a, b) {
        return b._score - a._score;
      });
      for (var i = 0; i < candidates.length && picks.length < 4; i++) {
        addPick(candidates[i]);
      }
    }

    picks.forEach(function (p, i) {
      p.blurb = writeBlurb(p, state, i === 0 && !isProteinItem(p));
    });

    return picks.slice(0, 4);
  }

  function cartAddUrl() {
    return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  }

  function addToCart(variantId, qty) {
    if (!variantId) return Promise.reject(new Error('No variant'));
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      if (window.APH && typeof window.APH.openCart === 'function') window.APH.openCart();
      else if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        try {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'aph-quiz' });
        } catch (e) {}
      }
      return data;
    });
  }

  function initQuiz(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';
    var sectionId = root.getAttribute('data-section-id') || '';
    var app = root.querySelector('[data-quiz-app]');
    if (!app) return;

    var cat = readJson('AphQuizCatalogue-' + sectionId) || {};
    var sachet = readJson('AphQuizSachet-' + sectionId) || {};
    var recipesRaw = readJson('AphQuizRecipes-' + sectionId) || '';
    var recipes = String(recipesRaw || '')
      .split('|')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);

    var state = { natty: null, goal: null };
    var steps = Array.prototype.slice.call(app.querySelectorAll('[data-quiz-step]'));
    var dots = Array.prototype.slice.call(app.querySelectorAll('[data-quiz-dot]'));
    var resultsEl = app.querySelector('[data-quiz-results]');
    var answersEl = app.querySelector('[data-quiz-answers]');
    var proteinExtra = app.querySelector('[data-quiz-protein-extra]');
    var recipesList = app.querySelector('[data-quiz-recipes-list]');

    function showStep(n) {
      steps.forEach(function (s) {
        s.classList.toggle('active', s.getAttribute('data-quiz-step') === String(n));
      });
      dots.forEach(function (d) {
        var i = parseInt(d.getAttribute('data-quiz-dot'), 10);
        d.classList.toggle('done', i < n);
        d.classList.toggle('active', i === n);
      });
    }

    function starHtml() {
      return (
        '<span class="star-rating"><span class="stars">' +
        STAR_SVG +
        STAR_SVG +
        STAR_SVG +
        STAR_SVG +
        STAR_SVG +
        '</span></span>'
      );
    }

    function buildCard(p, isPrimary) {
      var card = document.createElement('div');
      card.className = 'quiz-result-card' + (isPrimary ? ' is-primary' : '');
      var href = p.url || '/products/' + p.handle;
      var priceHtml = p.price
        ? '<span class="price">' + money(p.price) + '</span>' +
          (p.compare ? '<span class="price-compare">' + money(p.compare) + '</span>' : '')
        : '';
      var img = p.img
        ? '<img src="' + p.img + '" alt="' + (p.name || '').replace(/"/g, '') + '" loading="lazy" width="400" height="400">'
        : '<div class="ph-block"></div>';

      card.innerHTML =
        (isPrimary ? '<span class="quiz-result-primary-tag">Best match</span>' : '') +
        '<a href="' +
        href +
        '" class="quiz-result-media">' +
        img +
        '</a>' +
        '<div class="quiz-result-info">' +
        '<h3><a href="' +
        href +
        '">' +
        (p.name || p.handle) +
        '</a></h3>' +
        starHtml() +
        '<p class="quiz-result-blurb">' +
        (p.blurb || '') +
        '</p>' +
        '<div class="price-row">' +
        priceHtml +
        '</div>' +
        '<div class="quiz-result-cta">' +
        '<div class="qty-stepper">' +
        '<button type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
        '<span class="qty-value">1</span>' +
        '<button type="button" data-qty-plus aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="btn-roll accent sm" data-quiz-add-to-cart' +
        (p.id ? '' : ' disabled') +
        '>' +
        '<span class="btn-roll-wrap"><span class="btn-roll-inner"><span>Add</span><span>Add</span></span></span>' +
        '<div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg></div>' +
        '</button>' +
        '<div class="quiz-added-note" data-quiz-added>' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="15" height="15"><path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z" fill="currentColor"/></svg>' +
        'Added</div>' +
        '</div></div>';

      var qtyValue = card.querySelector('.qty-value');
      card.querySelector('[data-qty-minus]').addEventListener('click', function () {
        var v = parseInt(qtyValue.textContent, 10);
        if (v > 1) qtyValue.textContent = v - 1;
      });
      card.querySelector('[data-qty-plus]').addEventListener('click', function () {
        qtyValue.textContent = parseInt(qtyValue.textContent, 10) + 1;
      });
      var addBtn = card.querySelector('[data-quiz-add-to-cart]');
      if (addBtn && p.id) {
        addBtn.addEventListener('click', function () {
          if (addBtn.getAttribute('aria-busy') === 'true') return;
          var qty = parseInt(qtyValue.textContent, 10) || 1;
          if (window.APH && typeof window.APH.setAtcBusy === 'function') window.APH.setAtcBusy(addBtn, true);
          else addBtn.disabled = true;
          addToCart(p.id, qty)
            .then(function () {
              var note = card.querySelector('[data-quiz-added]');
              if (note) {
                note.classList.add('show');
                setTimeout(function () {
                  note.classList.remove('show');
                }, 2500);
              }
            })
            .catch(function () {})
            .finally(function () {
              if (window.APH && typeof window.APH.setAtcBusy === 'function') window.APH.setAtcBusy(addBtn, false);
              else addBtn.disabled = false;
            });
        });
      }
      return card;
    }

    function fillRecipes() {
      if (!recipesList) return;
      recipesList.innerHTML = '';
      recipes.forEach(function (line, idx) {
        var li = document.createElement('li');
        li.textContent = line;
        li.setAttribute('data-recipe-pick', String(idx + 1));
        li.setAttribute('tabindex', '0');
        li.setAttribute('role', 'button');
        li.addEventListener('click', function () {
          Array.prototype.forEach.call(recipesList.querySelectorAll('li'), function (el) {
            el.classList.remove('is-picked');
          });
          li.classList.add('is-picked');
        });
        li.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            li.click();
          }
        });
        recipesList.appendChild(li);
      });
    }

    function renderResults() {
      var list = buildCombo(state, cat);
      resultsEl.innerHTML = '';
      list.forEach(function (p, i) {
        resultsEl.appendChild(buildCard(p, i === 0));
      });
      if (answersEl) {
        /* Harry 2026-09-23: reword their answers in one short sentence. */
        var GOAL_PHRASE = { bulking: 'to bulk up', strength: 'to get stronger', weightloss: 'to lose weight', recovery: 'to recover faster' };
        var PATH_PHRASE = { natty: 'natural products only', sarms: 'SARMs', peptides: 'peptides' };
        if (GOAL_PHRASE[state.goal] && PATH_PHRASE[state.natty]) {
          answersEl.textContent =
            'You said you wanted ' +
            GOAL_PHRASE[state.goal] +
            " and you're open to " +
            PATH_PHRASE[state.natty] +
            '. Here is what other customers like you would have.';
        } else {
          answersEl.textContent = '';
        }
      }
      if (proteinExtra) proteinExtra.hidden = true;
    }

    app.querySelectorAll('[data-quiz-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-quiz-step]').getAttribute('data-quiz-step');
        if (step === '1') {
          state.goal = btn.getAttribute('data-value');
          showStep(2);
        }
        if (step === '2') {
          state.natty = btn.getAttribute('data-value');
          renderResults();
          showStep(3);
        }
      });
    });

    app.querySelectorAll('[data-quiz-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var from = parseInt(btn.closest('[data-quiz-step]').getAttribute('data-quiz-step'), 10);
        showStep(from - 1);
      });
    });

    var restartBtn = app.querySelector('[data-quiz-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        state = { natty: null, goal: null };
        if (proteinExtra) proteinExtra.hidden = true;
        if (answersEl) answersEl.textContent = '';
        if (resultsEl) resultsEl.innerHTML = '';
        showStep(1);
      });
    }

    var sachetBtn = app.querySelector('[data-quiz-add-sachet]');
    if (sachetBtn && sachet && sachet.id) {
      sachetBtn.addEventListener('click', function () {
        sachetBtn.disabled = true;
        addToCart(sachet.id, 1)
          .then(function () {
            var note = app.querySelector('[data-quiz-sachet-added]');
            if (note) {
              note.hidden = false;
              setTimeout(function () {
                note.hidden = true;
              }, 2500);
            }
          })
          .catch(function () {})
          .finally(function () {
            sachetBtn.disabled = false;
          });
      });
    } else if (sachetBtn && (!sachet || !sachet.id)) {
      sachetBtn.addEventListener('click', function () {
        if (sachet && sachet.url) window.location.href = sachet.url;
      });
    }

    var preGoal = '';
    try {
      preGoal = (new URLSearchParams(window.location.search).get('goal') || '').toLowerCase();
    } catch (err) {}
    if (preGoal === 'weight-loss') preGoal = 'weightloss';
    if (['bulking', 'strength', 'weightloss', 'recovery'].indexOf(preGoal) !== -1) {
      state.goal = preGoal;
      app.querySelectorAll('[data-quiz-step="1"] [data-quiz-option]').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-value') === preGoal);
      });
      showStep(2);
    } else {
      showStep(1);
    }
  }

  function boot() {
    document.querySelectorAll('[data-aph-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-aph-quiz]')) {
      e.target.querySelectorAll('[data-aph-quiz]').forEach(function (el) {
        delete el.dataset.bound;
        initQuiz(el);
      });
    }
  });
})();
